import { MessageCircle } from "lucide-react";

export const FloatingWhatsApp = () => {
  return (
    <a
      href="https://wa.me/41782135944"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Contacter Zion Solutions Suisse Sàrl par WhatsApp"
      className="group fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand text-white shadow-[0_12px_32px_rgba(20,61,42,0.35)] transition-[background-color,transform] duration-200 hover:bg-brand-deep hover:scale-105 active:scale-95"
    >
      <span
        aria-hidden="true"
        className="animate-soft-ping absolute inset-0 rounded-full bg-brand"
      />
      <MessageCircle className="relative h-6 w-6" strokeWidth={1.8} />
    </a>
  );
};
